// import React from 'react'

// import { Box, Text, Input } from 'system'
// import { Button } from './Button'
// import { Heading } from './Heading'
// import { ReactComponent as IconSendSVG } from '../assets/icon-send.svg'

// TODO: Implement HelpCard form submissions.
export const HelpCard = () => null

// export const HelpCard = props => (
//   <Box
//     bg="purple.100"
//     border="1px solid"
//     borderColor="purple.90"
//     borderRadius="4px"
//     color="gray.20"
//     fontSize="tiny"
//     p={3}
//     {...props}
//   >
//     <Heading as="h4" fontSize="tiny" color="purple.50" mb={1}>
//       Need help?
//     </Heading>
//     <Text as="p" lineHeight="copy" mb={2}>
//       Send{' '}
//       <Text as="span" display="inline" fontWeight="semibold">
//         Wall-to-Wall Studios
//       </Text>{' '}
//       a message. We’ll get back to you as soon as possible.
//     </Text>
//     <Input
//       as="textarea"
//       placeholder="Type your message&hellip;"
//       border="1px solid"
//       borderColor="purple.90"
//       borderRadius="4px"
//       color="gray.20"
//       display="block"
//       fontSize="tiny"
//       height="4rem"
//       mb={2}
//       p={1}
//       width="100%"
//       css={`
//         resize: none;

//         &::placeholder {
//           color: ${p => p.theme.colors.gray[50]};
//         }
//       `}
//     />
//     <Button type="submit" colorScheme="green" iconSVG={IconSendSVG} width={1}>
//       Send message
//     </Button>
//   </Box>
// )
